import BankingTransitionDeepLink from './BankingTransitionDeepLink';

export default BankingTransitionDeepLink;
